import dataModel from '../.././js/model.js';

let contextAnimations = () => {

    //grab URL parameter to determine experience
    let params = new URLSearchParams(document.location.search);
    let brandContextParam = params.get("brandContext");

    if(brandContextParam == 9) {
        $('.hero').prepend(`
            <div class="hero__tag temp__flexbox temp__ai--c temp__jc--c">NEW</div>
        `)
    }
}

export { contextAnimations as default };